export interface PaymentSwitchingData {
    payinActive: boolean;
    payoutActive: boolean;
}
